import { useEnvValue } from '@morningtrain/react-helpers'
import moment from 'moment'

export default function useActiveScheduleWeekday () {
  return useEnvValue('globals.active_schedule_weekday', moment().day())
}
